import { MFDListProps } from "@/services/financial-movement-desc.service";

export interface MFDFRProps {
  name: string;
  code: number;
}

export const getFinancialMovementsDescFilter = (
  event: MFDFRProps,
): Partial<MFDListProps> => {
  return {
    ...(event?.name
      ? {
          Nombre: event.name,
        }
      : {}),
    ...(event?.code
      ? {
          Codigo: event?.code,
        }
      : {}),
  };
};
